module.exports = __webpack_public_path__ + "img/dsn03.d0d82f0a.gif";